var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MatcCanvasPage",attrs:{"id":"CanvasNode"}},[_c('AnalyticToolbar',{ref:"toolbar"}),_c('AnalyticCanvas',{ref:"canvas"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }